import React from "react";
import { useStoreContext } from "@components/store/provider";
import { useCreateSwagContext } from "@contexts/create-swag-context";
import classNames from "classnames/bind";
import styles from "./main.module.scss";

import PaginatedButtons from "@stadium/ui/src/components/paginated-buttons";
import { useWithAnalytics } from "@stadium/services/analytics/hooks/use-with-analytics";
import {
  DropdownToggle,
  ResponsiveDrawerDropdown,
  DropdownItem,
} from "@stadium/ui/src/components/bootstrap-dropdown";

const cx = classNames.bind(styles);

const PER_PAGE_VALUES = [
  { key: "24", label: "24" },
  {
    key: "48",
    label: "48",
  },
  { key: "96", label: "96" },
];

const ListingPagination = ({
  total,
  perPage,
  currentPage,
  onPageChange,
  className,
  showPerPageDropdown,
  setPerPage,
  eventLocationAnalytics,
}) => {
  const { isNewSwagmagicHost } = useStoreContext();
  const { isSwagCreationShopFlow } = useCreateSwagContext();
  const withAnalytics = useWithAnalytics();

  const handlePageChange = React.useCallback(
    (pageNumber) => {
      if (eventLocationAnalytics?.track && pageNumber !== currentPage) {
        const direction = pageNumber > currentPage ? "next" : "prev";
        const { target, action, eventProperties } = eventLocationAnalytics;
        withAnalytics(undefined, {
          track: true,
          target,
          action,
          eventProperties: {
            ...eventProperties,
            page_number: pageNumber,
            direction,
          },
        })();
      }
      if (onPageChange) {
        onPageChange(pageNumber);
      }
    },
    [currentPage, eventLocationAnalytics, withAnalytics, onPageChange],
  );

  const pageCount = Math.ceil(total / perPage);
  if (pageCount <= 1) {
    return null;
  }
  return (
    <div
      className={cx("paginationPerpageWrap", {
        paginationNew: isNewSwagmagicHost,
        swagCreationShopFlow: isSwagCreationShopFlow,
      })}
    >
      <PaginatedButtons
        total={total}
        perPage={perPage}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        className={cx(className, "paginationWrap")}
      />
      {showPerPageDropdown && (
        <ResponsiveDrawerDropdown
          onSelect={(value) => setPerPage(Number(value))}
          menuClassName={cx("dropdDownMenu")}
          label={
            <DropdownToggle showDropdownIcon>
              <div className={cx("defaultHeading")}>Per Page: {perPage}</div>
            </DropdownToggle>
          }
          heading={<DropdownToggle>Per Page</DropdownToggle>}
        >
          {PER_PAGE_VALUES.map(({ key, label }) => (
            <DropdownItem isActive={perPage === Number(key)} key={key} eventKey={key}>
              <div className={cx("defaultListItem")}>{label}</div>
            </DropdownItem>
          ))}
        </ResponsiveDrawerDropdown>
      )}
    </div>
  );
};

export default ListingPagination;
